module.exports = __webpack_public_path__ + "static/media/rate.d6b0c905.svg";